export const ReportType = {
  FLOW_ENGAGEMENT: 'flow-engagement',
  FLOW_ESCALATIONS: 'flow-escalation',
  FLOW_TOTALS: 'flow-totals',
};
